/* eslint-disable import/no-cycle */
import { configureStore } from '@reduxjs/toolkit'

import aggregateSearches from './aggregateSearches'
import dataPrivacy from './dataPrivacy'
import documentCompare from './documentCompare'
import modals from './modals'
import page from './page'
import persisted from './persisted'
import scrollPositions from './scrollPositions'
import selectedText from './selectedText'
import termAnalyticsSearches from './termAnalyticsSearches'
import termTypesSearch from './termSearch'

const store = configureStore({
  reducer: {
    aggregateSearches,
    dataPrivacy,
    documentCompare,
    modals,
    page,
    persisted,
    scrollPositions,
    selectedText,
    termAnalyticsSearches,
    termTypesSearch,
  },
})

export default store
